angular.module('SpidApp')

.factory('AgencyService',
	    ['Restangular', '_', 'Agency',
function (Restangular,   _,   Agency) {
	var AgencyService = {
		all: function () {
			return Restangular.all('agencies').getList().then(function (agenciesData) {
				return _.map(agenciesData, function (agencyData) {
					return new Agency(agencyData)
				})
			})
		},

		find: function (id) {
			if (!id) {
				throw 'AgencyService::find() - Missing parameters'
			}

			return Restangular.one('agencies', id).get().then(function (agencyData) {
				return new Agency(agencyData)
			})
		},
		save: function (agency) {
			if (!agency) {
				throw 'AgencyService::save() - Missing parameters'
			}

			var agencyRequest = Restangular.one("agencies", agency.id)
			return agencyRequest.customPOST(agency, null, {}, {})
		},
		bulkSave : function(agencies) {
			if (!agencies) {
				throw 'AgencyService::bulkSave() - Missing parameters'
			}
			
			return Restangular.one("agencies").post(null, agencies);
		}
	}

	return AgencyService
}])
